export const INBOUND_DATE = 'Inbound_date';
export const OUTBOUND_DATE = 'Outbound_date';
export const AUTOCOMPLETE_TYPE = 'AutoComplete';
export const SUBMIT_TEXT = 'Submit';
export const RADIOBUTTONLIST_TEXT = 'RadioButtonList';
export const DATE_TEXT = 'Date';
export const RETURN_LABEL_TEXT = 'Return';
export const FROM_LOCATION_TEXT = 'from_location';
export const TO_LOCATION_TEXT = 'to_location';
export const FORM_TYPE_TO_CHECK_FLIGHT = 'TravelPayout-Flight';